import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import { formatDate } from "utils/format.util";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import { DEPLOYMENT_DETAILS_FORM } from "features/planner/planner.constants";

const DeploymentDetailsForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} id={DEPLOYMENT_DETAILS_FORM.ID}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Field
            label="Location"
            name={DEPLOYMENT_DETAILS_FORM.GROUP_NAME}
            component={ReadOnlyField}
          />
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <Field
            label="Start"
            name={DEPLOYMENT_DETAILS_FORM.START_DATE}
            component={ReadOnlyField}
            formatDate={formatDate}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            label="End"
            name={DEPLOYMENT_DETAILS_FORM.END_DATE}
            component={ReadOnlyField}
            formatDate={formatDate}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            label="Shift"
            component={ReadOnlyField}
            name={DEPLOYMENT_DETAILS_FORM.SHIFT}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            label="Qualification"
            component={ReadOnlyField}
            name={DEPLOYMENT_DETAILS_FORM.QUALIFICATION_NAME}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default compose(React.memo)(DeploymentDetailsForm);
